import axios from "axios";

let BASE_URL = "https://staging.aimantra.info";
// BASE_URL = "https://5rn0m63d-8000.inc1.devtunnels.ms";
// BASE_URL = 'https://csms.aimantra.info';
// BASE_URL = 'https://6mpwdglt-8000.inc1.devtunnels.ms'
const BASE_URL2 = "https://bd.aimantra.info";

// let BASE_URL = "https://n00nmkv7-8002.inc1.devtunnels.ms";
// BASE_URL = "https://n00nmkv7-8005.inc1.devtunnels.ms";
// BASE_URL = "https://n00nmkv7-8000.inc1.devtunnels.ms";
//@G-ENG
// let BASE_URL = "https://g-eng.aimantra.info";

//@SC
// let BASE_URL = "https://sc.aimantra.info";

//@Tester Lenovo
// let BASE_URL = "https://1dmjlcrf-8000.inc1.devtunnels.ms";

const currentUrl = window.location.href;
const urlParts = currentUrl.split("/");
const FRONTEND_URL = urlParts[0] + `//` + urlParts[2];

const domainParts = urlParts[2].split(".");
// console.log(domainParts);
let client = domainParts[1];

if (domainParts[1] === "aimantra") {
  client = domainParts[0];
  // console.log("client0");
}

let IMAGE_URL = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
let TESTING_URL = "https://n00nmkv7-8005.inc1.devtunnels.ms";
let TESTING_URL_actual = "https://bd.aimantra.info";
if (client) {
  if (client === "csms") {
    BASE_URL = "https://6mpwdglt-8001.inc1.devtunnels.ms";
    BASE_URL = "https://csms.aimantra.info";
    // console.log("BASE_URL A");
    // console.log(BASE_URL);
  } else if (client === "almondz") {
    BASE_URL = "https://6mpwdglt-8001.inc1.devtunnels.ms";
    // console.log("BASE_URL B");
    // console.log(BASE_URL);
  } else if (client === "businessdevelopment") {
    BASE_URL = `https://bd.aimantra.info`;
    // // console.log("BASE_URL C");
    // BASE_URL = 'https://6mpwdglt-8000.inc1.devtunnels.ms'
  }
} else {
  BASE_URL = `https://bd.aimantra.info`;

  // BASE_URL = "https://staging.aimantra.info";

  // BASE_URL = "https://bkzrdhbv-8008.inc1.devtunnels.ms";
  // BASE_URL = 'https://6mpwdglt-8000.inc1.devtunnels.ms'custom

  console.log("BASE_URL C");
  console.log(BASE_URL);
}
switch (client) {
  case "cipl":
    IMAGE_URL = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
    break;
  case "g-eng":
    IMAGE_URL = "https://geng-aimantra.s3.ap-south-1.amazonaws.com/";
    break;
  case "sc":
    IMAGE_URL = "https://spacecreator-aimantra.s3.ap-south-1.amazonaws.com/";
    break;
  case "csms":
    IMAGE_URL = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
    break;
  case "almondz":
    IMAGE_URL = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
    break;
  default:
    IMAGE_URL = "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";
    break;
}

// Login, forgot-password, and reset stay public. Every other API
// inherits AuthenticatedAPIView on the backend and requires a JWT.
const PUBLIC_AUTH_PATHS = [
  "/user/login/",
  "/user/forgotpassword/",
  "/user/forgotpasswordchange/",
];

export function getAccessToken() {
  try {
    const token = sessionStorage.getItem("access_token");
    if (!token || token === "null" || token === "undefined") return null;
    return token;
  } catch {
    return null;
  }
}

export function isPublicAuthRequest(url = "") {
  const value = String(url);
  return PUBLIC_AUTH_PATHS.some((path) => value.includes(path));
}

export function getAuthHeaders(extra = {}) {
  const token = getAccessToken();
  return {
    accept: "application/json",
    ...extra,
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

function authHeaders(contentType) {
  const token = getAccessToken();
  const headers = { "Content-Type": contentType };
  if (contentType === "application/json") headers.accept = "application/json";
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
}

// Read at call time so a token saved after login is picked up.
const AUTH = {
  get headers() {
    return authHeaders("application/json");
  },
};

const AUTHH = {
  get headers() {
    return authHeaders("multipart/form-data");
  },
};

export function applyJwtAuth(config) {
  const url = `${config.baseURL || ""}${config.url || ""}`;
  if (isPublicAuthRequest(url)) return config;

  const token = getAccessToken();
  if (!token) return config;

  config.headers = config.headers || {};
  if (typeof config.headers.set === "function") {
    config.headers.set("Authorization", `Bearer ${token}`);
  } else {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}

if (!axios.__bdJwtInterceptor) {
  axios.__bdJwtInterceptor = axios.interceptors.request.use((config) =>
    applyJwtAuth(config),
  );
}

export {
  BASE_URL,
  AUTH,
  AUTHH,
  FRONTEND_URL,
  IMAGE_URL,
  TESTING_URL,
  TESTING_URL_actual,
  BASE_URL2,
};
